const Default = ({row}) => {
    return row?.label || '';

}

export default Default;